/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentVoterDB_Voters.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Voter API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, September 30, 2019 - 09:59:53 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/30/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const VoterDB_Voters = {
    all: (limit) => requests.get(`/Voters?limit=${limit}`),
    voterCount: (exporttypeid, countyid, precinctid, voteruid, firstname, middlename, lastname, address1, city, zipcode) => requests.get(`/VoterCount?exporttypeid=${exporttypeid}&countyid=${countyid}&precinctid=${precinctid}&voteruid=${voteruid}&firstname=${firstname}&middlename=${middlename}&lastname=${lastname}&address1=${address1}&city=${city}&zipcode=${zipcode}`),
    voterShort: (exporttypeid, countyid, precinctid, voteruid, firstname, middlename, lastname, address1, city, zipcode) => requests.get(`/VoterShort?exporttypeid=${exporttypeid}&countyid=${countyid}&precinctid=${precinctid}&voteruid=${voteruid}&firstname=${firstname}&middlename=${middlename}&lastname=${lastname}&address1=${address1}&city=${city}&zipcode=${zipcode}`),
    get: voterid => requests.get(`/Voter/${voterid}`),
    create: voter => requests.post(`/Voters`, voter),
    update: (voterid, voter) => requests.put(`/Voter/${voterid}`, voter),
    delete: voterid => requests.del(`/Voter/${voterid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentVoterDB_Voters.js